export const getCanonicalUrl = (cmsCanonical) => {

    // Get the current URL
    var currentUrl = window.location.href;

    // Ensure the current URL contains 'www', if it doesn't, add it. Client wants to ensure www is part of the canonical URL
    if (currentUrl.indexOf('www.') === -1) {
        currentUrl = currentUrl.replace(/^(https?:\/\/)/, '$1www.');
    }

    // If cmsCanonical is empty or undefined, return the full path of the current URL
    if (!cmsCanonical) {
        return currentUrl;
    }

    // Parse the current URL
    var currentUrlObj = new URL(currentUrl);

    // Parse the cmsCanonical
    var cmsCanonicalObj = new URL(cmsCanonical, currentUrl);

    // Check if cmsCanonical is a relative path
    if (!cmsCanonicalObj.hostname) {
        // If it's a relative path, combine it with the current URL's origin
        return currentUrlObj.origin + cmsCanonical;
    }

    // If cmsCanonical has a valid hostname (domain), ensure it contains 'www' and use it as the canonical URL
    // this will look strange on non production environments but they want to ensure the www is there
    // ie. https://www.lacantina.jeld-wen.local/products/sliding-doors --  there is no www.lacantina.jeld-wen.local
    // it is just mirroring my local url
    var userInputHostname = cmsCanonicalObj.hostname;
    if (userInputHostname.indexOf('www.') === -1) {
        userInputHostname = 'www.' + userInputHostname;
    }

    return cmsCanonicalObj.protocol + '//' + userInputHostname + cmsCanonicalObj.pathname;
}
